<app-dialog (actionButtonClicked)="onFormSubmit($event)" [config]="data.config">
    <ng-container dialog-title>Add Route Set</ng-container>

    <ng-container *ngIf="form && form.formGroup" dialog-process-in-progress>
        <form [formGroup]="form.formGroup" class="row add-exchange-form">

            <ng-container [formArrayName]="form.routeSetFormControlsRouteArraySelector">
                <div
                    *ngFor="let control of form.controls.routeSets; let i = index"
                    class="col-md-12"
                    [ngClass]="{'mb-3': control.errors.length > 0}"
                >
                    <div class="row ">
                        <div class="col-md-2">
                            <app-checkbox
                                [formControlName]="i"
                                [control]="control"
                            >
                            </app-checkbox>
                        </div>
                        <div class="col-md-10 font-weight-bold">{{ control.placeholder }}</div>
                    </div>


                    <div class="row">
                        <div class="col-md-2">
                            <!-- Empty div to align with checkbox above -->
                        </div>
                        <div class="col-md-10">
                            {{ getRouteSetDetails(control.value) }}
                        </div>
                    </div>
                    <hr/>

                </div>

                <div *ngIf='form.routesErrors.length > 0' class="form-text text-danger mt-3">
                    <span *ngFor="let error of form.routesErrors">{{ error }}</span>
                </div>
            </ng-container>
        </form>
    </ng-container>
</app-dialog>
